import { View } from 'react-native';

import { connectStyle } from '@shoutem/theme';
import { connectAnimation } from '@shoutem/animation';

const AnimatedScreen = connectAnimation(View);
const Screen = connectStyle('shoutem.ui.Screen')(AnimatedScreen);

export {
  Screen,
};



// WEBPACK FOOTER //
// ./node_modules/@shoutem/ui/components/Screen.js